export type Urgency = "overdue" | "soon" | "normal";

/**
 * Bestimmt die Dringlichkeit anhand eines Frist-Datums (ISO-String).
 * - overdue: Frist <= heute
 * - soon: Frist <= heute + 14 Tage
 * - normal: alles andere oder kein Datum
 */
export const getUrgency = (frist?: string): Urgency => {
  if (!frist) return "normal";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const fristDate = new Date(frist);
  fristDate.setHours(0, 0, 0, 0);

  if (fristDate <= today) return "overdue";

  const inFourteenDays = new Date(today);
  inFourteenDays.setDate(inFourteenDays.getDate() + 14);
  if (fristDate <= inFourteenDays) return "soon";

  return "normal";
};

/** Abstand zum Fälligkeitsdatum in seinen Teilen – fürs Kalenderblatt der Termine */
export interface DueDistance {
  /** „seit“, „in“ oder – am Fälligkeitstag – leer */
  prefix: "seit" | "in" | "";
  /** Zahl der Tage bzw. Wochen; am Fälligkeitstag „heute“ */
  value: string;
  /** „Tag“, „Tagen“, „Woche“, „Wochen“; am Fälligkeitstag leer */
  unit: string;
}

/**
 * Wie weit das Fälligkeitsdatum von heute entfernt ist: unter zwei Wochen in Tagen, ab zwei
 * Wochen in vollen Wochen – nach vorn wie nach hinten („seit 4 Tagen“, „in 12 Tagen“,
 * „in 2 Wochen“, „in 26 Wochen“).
 */
export const dueDistance = (dateStr: string): DueDistance => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr);
  target.setHours(0, 0, 0, 0);
  const days = Math.round((target.getTime() - today.getTime()) / 86_400_000);
  if (days === 0) return { prefix: "", value: "heute", unit: "" };

  const prefix = days < 0 ? "seit" : "in";
  const abs = Math.abs(days);
  if (abs < 14) {
    return { prefix, value: String(abs), unit: abs === 1 ? "Tag" : "Tagen" };
  }
  const weeks = Math.floor(abs / 7);
  return { prefix, value: String(weeks), unit: "Wochen" };
};
